<template>
  <div class="prolong-rules">
    <div class="prolong-rules__title">
      <slot name="title"/>
    </div>
    <div class="prolong-rules__description">
      <slot name="description"/>
    </div>
    <sPopover
      v-if="tender.biddingType.prolongationRuleAvailable"
      ref="popoverProlongRule"
      :disabled="disabled"
      placement="bottom"
      popper-class="prolong-rules__items"
      trigger="click"
      width="400">
      <div>
        <ProlongRulesItem
          v-for="ruleItem in rules"
          :key="ruleItem.code"
          :check="ruleItem.code===currentProlongRule.code"
          :item="ruleItem"
          @click="changeRule($event.code)"/>
      </div>
      <template #reference="{show}">
        <div
          class="prolong-rules__current">
          <sTooltip
            :border="false"
            class="mr-2"
            content="У вас немає правил продовження для вибору, або воно тільки одне"
            :disabled="!disabled"
            type="white">
            <div class="prolong-rules__current-label">
              {{ currentProlongRule.name }}
            </div>
          </sTooltip>
          <sIcon
            class="ml-2 my-auto"
            :color="disabled ? 'grey' : 'var(--text-color)'"
            :rotate="show ? '-180' : '0'"
            size="10"
            type="arrow"/>
        </div>
      </template>
    </sPopover>
  </div>
</template>
<script>
import ProlongRulesItem from 'components/tenders/tender creation/ProlongRulesItem.vue'

export default {
  name: 'ProlongRules',
  methods: {
    changeRule(code) {
      if (this.tender.prolongRuleCode === code) {
        return
      }
      const result = this.$_.cloneDeep(this.tender)
      result.prolongRuleCode = code
      this.$emit('update:tender', result)
      this.$nextTick(() => {
        this.$refs.popoverProlongRule.showPopper = false
      })
    }
  },
  computed: {
    disabled() {
      return !this.rules.length
    },
    currentProlongRule() {
      return this.rules?.find(i => i.code === this.tender.prolongRuleCode) || {code: null, name: this.$t('Tenders.NoAutoRenewal')}
    }
  },
  components: {
    ProlongRulesItem
  },
  props: {
    tender: {
      type: Object
    },
    rules: {
      type: Array
    }
  },
}
</script>
<style>
.prolong-rules__items {
  border: 2px solid var(--color-main-green);
  background: var(--v-main__light_green-base);
}
</style>
<style scoped lang="scss">
.prolong-rules {
  &__title {
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.16px;
  }
  &__description {
    opacity: 0.5;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
  }
  &__current {
    cursor: pointer;
    margin-top: 10px;
    min-height: 40px;
    height: 40px;
    border-radius: 31px;
    background: var(--white-color);
    border: 2px solid var(--color-main-green);
    padding: 9px 15px;
    line-height: 18px;
    box-sizing: border-box;
    width: 100%;
    font-size: inherit;
    color: var(--text-color);

    display: grid;
    transition: 0.25s all;
    grid-template-columns: auto 16px;
    &-label {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
